export default {"src":"/_next/static/media/notebook.4f425fc3.svg","height":28,"width":35};